import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OturumSaglayici } from './lib/oturum'
import App from './App'

const sorguIstemcisi = new QueryClient({
  defaultOptions: {
    queries: {
      // Beyan/mutabakat ekranları taze veri ister; sessiz bayat veri yanlış
      // karar verdirir. Odak dönüşünde yeniden çekmek yeterli.
      staleTime: 30_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('kok')!).render(
  <StrictMode>
    <QueryClientProvider client={sorguIstemcisi}>
      <BrowserRouter>
        <OturumSaglayici>
          <App />
        </OturumSaglayici>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
